module.exports = __webpack_public_path__ + "static/img/completed.9ea0ebb.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/completed.svg
// module id = Owb0
// module chunks = 1